export default "__VITE_ASSET__Blt45u4u__"